// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XszBd","newExpiryDate":"styles_newExpiryDate__1YMMf","footer":"styles_footer__UXl3K"};